var map = {
	"./plp-unlabelled-images/OriginalPrice/index.js": 8107,
	"./plp-unlabelled-images/ProductDeal/index.js": 8964,
	"./plp-unlabelled-images/ProductPrice/index.js": 3227,
	"./plp-unlabelled-images/v2/index.js": 3573,
	"./plp-unlabelled-images/v3/index.js": 9080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7988;